import { Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup } from '@mui/material'
import Grid from '@mui/material/Grid'
import useStyles from './styles/Welcome.styles'
import alarm from './../../assets/images/alarm.png'
import chain from './../../assets/images/chain.png'
import clock from './../../assets/images/clock.png'
import useActivationObject from '../providers/ActivationObjectProvider/hooks/useActivationObject'
import TagManager from 'react-gtm-module'
import { ChangeEvent, useState, MouseEvent, useEffect } from 'react'

const Welcome = () => {
    const { create, isUpdating, finish } = useActivationObject()
    const [pcoConnected, setPcoConnected] = useState<boolean>()
    const [waChange, setWaChange] = useState<boolean>()

    const handleActivation = async () => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'activateHome',
            },
        })
        typeof waChange !== 'undefined' && create({ isExchangeForNew: waChange })
    }

    const handleFinish = (e: MouseEvent) => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'finishHome',
            },
        })
        finish()
    }

    const handlePcoRadio = (e: ChangeEvent<HTMLInputElement>) => {
        setPcoConnected((e.target as HTMLInputElement).value === 'true')
    }

    const handleWaRadio = (e: ChangeEvent<HTMLInputElement>) => {
        setWaChange((e.target as HTMLInputElement).value === 'true')
    }

    const classes = useStyles()
    return (
        <Box p={5} maxWidth={625}>
            <Paper>
                <Box p={7} textAlign='center'>
                    <Box p={1} margin={'center'} paddingBottom={0}>
                        AKTIVACE SLUŽBY
                    </Box>
                    <Box p={2} margin={'center'} paddingTop={0} fontSize={'0.875rem'}>
                        Vítáme Vás v bezpečnostním centru JABLOTRON.
                    </Box>
                    <Box>
                        <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            <Grid item xs={4} sm={2} md={2} display={'inline'}>
                                <Box className={classes.imageBox}>
                                    <img src={alarm} alt='alarm'></img>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={6} md={10}>
                                <Box className={classes.contentBox}>
                                    <Box>Ke svému novému alarmu JABLOTRON získáváte</Box>
                                    <Box>
                                        <b>3 měsíce</b> služeb střežení zdarma
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={2} md={2} display={'inline'}>
                                <Box className={classes.imageBox}>
                                    <img src={chain} alt='chain'></img>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={6} md={10}>
                                <Box className={classes.contentBoxExtraPadding}>
                                    A to navíc <b>bez jakýchkoliv závazků</b>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={2} md={2} display={'inline'}>
                                <Box className={classes.imageBox}>
                                    <img src={clock} alt='clock'></img>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={6} md={10}>
                                <Box className={classes.contentBoxExtraPadding}>
                                    Aktivace vám nezabere více než <b>10 minut</b>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box p={2} paddingTop={4} margin={'center'} fontSize={'0.875rem'}>
                            K aktivaci budeme potřebovat Vaše osobní údaje, informace o objektu a případné identifikátory již
                            existujících smluv.
                        </Box>
                        <Box>
                            <FormControl>
                                <FormLabel id='pco-radio-buttons-group'>
                                    Je objekt připojen na jiný pult centralizované ochrany?
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby='pco-radio-buttons-group'
                                    value={pcoConnected}
                                    onChange={handlePcoRadio}
                                    sx={{ justifyContent: 'center' }}
                                >
                                    <FormControlLabel value={true} control={<Radio />} label='Ano' />
                                    <FormControlLabel value={false} control={<Radio />} label='Ne' />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                        <Box>
                            <FormControl>
                                <FormLabel id='wa-radio-buttons-group'>
                                    Jedná se o výměnu již registrovaného zabezpečovacího zařízení za nové?
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby='wa-radio-buttons-group'
                                    value={waChange}
                                    onChange={handleWaRadio}
                                    sx={{ justifyContent: 'center' }}
                                >
                                    <FormControlLabel value={true} control={<Radio />} label='Ano' />
                                    <FormControlLabel value={false} control={<Radio />} label='Ne' />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                        <Box paddingRight={17} paddingLeft={17}>
                            <Button
                                color='primary'
                                variant='contained'
                                fullWidth
                                onClick={handleActivation}
                                disabled={isUpdating || pcoConnected || pcoConnected === undefined || waChange === undefined}
                                startIcon={isUpdating && <CircularProgress size={20} />}
                            >
                                Aktivovat nový objekt
                            </Button>
                        </Box>
                        <Box paddingRight={17} paddingLeft={17}>
                            <Button
                                color='error'
                                variant='contained'
                                fullWidth
                                onClick={handleFinish}
                                disabled={isUpdating || !!!pcoConnected}
                                startIcon={isUpdating && <CircularProgress size={20} />}
                            >
                                Ukončit aktivaci
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default Welcome
